
import React, { useEffect } from 'react';
import { useState } from 'react';

function LottieImage({ animationData, bookingError, containerClass }) {

  const [lottie, setLottie] = useState({
    shouldRender: false,
    Lottie: null,
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('react-lottie').then((module) => {
        setLottie({ Lottie: module.default, shouldRender: true });
      });
    }
  }, [])

  const defaultOptions = {
    loop: !bookingError,
    autoplay: !bookingError,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  const { shouldRender, Lottie } = lottie
  return (
    <div className={containerClass}>
      {shouldRender && Lottie ? (
        <Lottie options={defaultOptions} isStopped={bookingError && true} isClickToPauseDisabled={true} />
      ) : (
        <></>
      )}
    </div>
  );
}
export default LottieImage